import { AxisSwitcher, BorderGridContainer, GridBox, H2, PortableText, Section } from '@ahmdigital/ui';
import { isEmpty, map } from 'lodash/fp';
import React from 'react';

import styles from './styles.module.sass';
import SummaryWithImageItem from './components/summary-with-image-item';

type SummariesProps = {
  slogan?: unknown[];
  summary?: unknown[];
  topicGroup?: {
    imageObject?: {
      caption?: string;
      image?: {
        asset?: {
          url?: string;
        };
      };
    };
    mediaObject?: {
      description?: string;
    }[];
    name?: string;
    slogan?: unknown[];
  }[];
};

const Summaries = ({ slogan, summary, topicGroup }: SummariesProps) => {
  if (isEmpty(topicGroup)) {
    return null;
  }

  const summaryWithImageItemPerRow = 1;

  return (
    <BorderGridContainer>
      <GridBox padding="1rem">
        <Section variant={['paddingTopSpacer1', 'paddingBottomSpacer1', styles.section]}>
          {slogan && (
            <H2 className={styles.slogan} variant="marginBottomSpacer8">
              {/* @ts-expect-error [🤖 PLEASE FIX 🤖]: Type 'unknown[]' is not assignable to type 'PortableTextSource | undefined'. */}
              <PortableText source={slogan} />
            </H2>
          )}
          {/* @ts-expect-error [🤖 PLEASE FIX 🤖]: Type 'unknown[]' is not assignable to type 'PortableTextSource | undefined'. */}
          {summary && <PortableText source={summary} variant={styles.summary} />}
          {/* @ts-expect-error - Automatic, Please fix when editing this file */}
          <AxisSwitcher key={topicGroup.id} space="0" limit={summaryWithImageItemPerRow} threshold="70rem">
            {/* @ts-expect-error - Automatic, Please fix when editing this file */}
            {map.convert({ cap: false })((summaryItem, index) => {
              const isEven = index % 2 === 1;
              return (
                <SummaryWithImageItem key={index} reverseColumn={isEven} refersToItemExplainedTerm={summaryItem} />
              );
            }, topicGroup)}
          </AxisSwitcher>
        </Section>
      </GridBox>
    </BorderGridContainer>
  );
};

Summaries.defaultProps = {
  slogan: '',
  summary: '',
  topicGroup: null,
};

export default Summaries;
